export default "__VITE_ASSET__TEmvuLT6__"